import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

import {
  FiPhoneCall,
  FiShare2,
} from "react-icons/fi";

import { FaUserCircle } from "react-icons/fa";

import {
  toggleLike,
  toggleVideoLike,
} from "../firebase";

import { db } from "../firebase";

import "../styles/ShopDetail.css";
import "../styles/main.css";
import "../styles/Videos.css";

import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

export default function ShopDetail() {
  const { shopId } = useParams();
  const navigate = useNavigate();

  const { user } = useAuth();
  const { addToCart } = useCart();

  const [shop, setShop] = useState(null);
const [products, setProducts] = useState([]);

const [shopPosts, setShopPosts] = useState([]);
const [postsLoading, setPostsLoading] = useState(true);

const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadShop();
  }, [shopId]);

  async function loadShop() {
    try {
      setLoading(true);

      const shopRef = doc(db, "shops", shopId);
      const shopSnap = await getDoc(shopRef);

      if (!shopSnap.exists()) {
        setLoading(false);
        return;
      }

      const shopData = {
        id: shopSnap.id,
        ...shopSnap.data(),
      };

      setShop(shopData);

// ==========================================
// LOAD THIS SHOP OWNER'S POSTS DIRECTLY
// FROM FIRESTORE
// ==========================================

try {
  setPostsLoading(true);

  console.log(
    "🏪 Shop:",
    shopData["Shop Name"]
  );

  console.log(
    "🏪 Shop UID:",
    shopData.uid
  );

  // ------------------------------------------
  // POSTS
  // ------------------------------------------

  const postsQuery = query(
    collection(db, "posts"),
    where("uid", "==", shopData.uid)
  );

  const postsSnap = await getDocs(postsQuery);

  const ownerPosts = postsSnap.docs.map(
    (postDoc) => ({
      id: postDoc.id,
      ...postDoc.data(),
      postType: "post",
    })
  );

  console.log(
    "📝 Shop posts found:",
    ownerPosts.length,
    ownerPosts
  );

  // ------------------------------------------
  // VIDEOS
  // ------------------------------------------

  let ownerVideos = [];

  try {
    const videosQuery = query(
      collection(db, "videos"),
      where("uid", "==", shopData.uid)
    );

    const videosSnap = await getDocs(
      videosQuery
    );

    ownerVideos = videosSnap.docs.map(
      (videoDoc) => ({
        id: videoDoc.id,
        ...videoDoc.data(),
        postType: "video",
      })
    );

    console.log(
      "🎥 Shop videos found:",
      ownerVideos.length,
      ownerVideos
    );

  } catch (videoError) {
    console.error(
      "Video loading failed:",
      videoError
    );
  }

  // ------------------------------------------
  // MERGE POSTS + VIDEOS
  // ------------------------------------------

  const combined = [
    ...ownerPosts,
    ...ownerVideos,
  ].sort(
    (a, b) =>
      new Date(b.createdAt) -
      new Date(a.createdAt)
  );

  console.log(
    "✅ TOTAL SHOP POSTS:",
    combined.length
  );

  setShopPosts(combined);

} catch (postError) {

  console.error(
    "❌ Failed to load shop posts:",
    postError
  );

  setShopPosts([]);

} finally {

  setPostsLoading(false);

}

      const q = query(
        collection(db, "shopproducts"),
        where("shopId", "==", shopId),
        where("active", "==", true)
      );

      const productSnap = await getDocs(q);

      setProducts(
        productSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );

    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  }

  if (loading) {
    return (
      <div className="shop-detail-page">
        Loading...
      </div>
    );
  }

  if (!shop) {
    return (
      <div className="shop-detail-page">
        Shop not found.
      </div>
    );
  }

  const shopType =
  shop["Type (Premium/Normal)"] ||
  shop.Type ||
  "Normal";

const isPremium =
  String(shopType)
    .toLowerCase()
    .includes("premium");


  function handleAddToCart(product) {

  addToCart({
    type: "shop",

    id: product.id,

    shopId: shop.id,

    shopName: shop["Shop Name"],

    ownerUid: shop.uid,

    name: product.name,

    brand: product.brand || "",

    image: product.image,

    price: product.offerPrice || product.price,

    mrp: product.price,

    stock: product.stock,
  });

  alert(`${product.name} added to cart.`);
}

// ==========================================
// LIKE SHOP POST
// ==========================================

async function handlePostLike(post) {
  if (!user) {
    navigate("/login");
    return;
  }

  try {
    const likes = post.likes || [];
    const liked = likes.includes(user.uid);

    if (post.videoUrl) {
      await toggleVideoLike(
        post.id,
        user.uid,
        liked
      );
    } else {
      await toggleLike(
        post.id,
        user.uid,
        liked
      );
    }

    // ==========================================
// REFRESH SHOP POSTS AFTER LIKE
// ==========================================

const postsQuery = query(
  collection(db, "posts"),
  where("uid", "==", shop.uid)
);

const postsSnap = await getDocs(postsQuery);

const ownerPosts = postsSnap.docs.map(
  (postDoc) => ({
    id: postDoc.id,
    ...postDoc.data(),
    postType: "post",
  })
);

// Videos
let ownerVideos = [];

try {

  const videosQuery = query(
    collection(db, "videos"),
    where("uid", "==", shop.uid)
  );

  const videosSnap = await getDocs(
    videosQuery
  );

  ownerVideos = videosSnap.docs.map(
    (videoDoc) => ({
      id: videoDoc.id,
      ...videoDoc.data(),
      postType: "video",
    })
  );

} catch (videoError) {

  console.error(
    "Video refresh failed:",
    videoError
  );

}

const combined = [
  ...ownerPosts,
  ...ownerVideos,
].sort(
  (a, b) =>
    new Date(b.createdAt) -
    new Date(a.createdAt)
);

setShopPosts(combined);


  } catch (err) {
    console.error(
      "Failed to like post:",
      err
    );
  }
}

  return (
    <div className="shop-detail-page">

      {/* Banner */}

      <div className="shop-banner">

        <img
          src={shop["Shop Image"]}
          alt={shop["Shop Name"]}
          className="shop-banner-image"
        />

        <div className="shop-banner-content">

          <h2>{shop["Shop Name"]}</h2>

          <span className="shop-premium-badge">
  {shopType}
</span>

          <p>
            {shop.Location}
          </p>

          {shop["Mobile Number"] && (

            
            <div className="shop-actions">

  <a
    href={`tel:${shop["Mobile Number"]}`}
    className="shop-call-btn"
  >
    <FiPhoneCall />
    Call
  </a>

  <a
    href={`https://wa.me/91${shop["Mobile Number"]}`}
    className="shop-whatsapp-btn"
  >
    WhatsApp
  </a>

  <button
  type="button"
  className="shop-share-btn"
  onClick={async () => {
    const shopLink =
      window.location.href;

    const shareText =
      `📍 ${shop["Shop Name"]}\n` +
      `${shop.Location || ""}\n\n` +
      `Check this shop on Eyal App!`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: shop["Shop Name"],
          text: shareText,
          url: shopLink,
        });
        return;
      } catch (error) {
        if (error?.name === "AbortError") {
          return;
        }
        console.error(
          "Shop share failed:",
          error
        );
      }
    }

    const whatsappText =
      `${shareText}\n\n${shopLink}`;

    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        whatsappText
      )}`,
      "_blank",
      "noopener,noreferrer"
    );
  }}
>
  <FiShare2 />
  Share
</button>


{/* hidden 
  <a
    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(shop.Address || shop.Location)}`}
    className="shop-direction-btn"
    target="_blank"
    rel="noreferrer"
  >
    Direction
  </a>
  */}

</div>
          )}

        </div>

      </div>

      {/* About */}

      <div className="shop-section">

        <h3>About</h3>

        <p>
          {shop.Description || "No description available."}
        </p>

      </div>

      {/* Address */}

      <div className="shop-section">

        <h3>Address</h3>

        <p>
          {shop.Address || "-"}
        </p>

      </div>

      {/* Opening Hours */}

      <div className="shop-section">

        <h3>Opening Hours</h3>

        <p>
          {shop["Opening Time"] || "--"} - {shop["Closing Time"] || "--"}
        </p>

      </div>

     
{/* Products */}

{isPremium && (
  <div className="shop-section">

    <div className="section-header">

      <h3>
        Products ({products.length})
      </h3>

      {user && shop.uid === user.uid && (
        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 10,
          }}
        >

          {/* MANAGE PRODUCTS */}
          <button
            className="manage-btn"
            onClick={() =>
              navigate(`/shop/manage/${shop.id}`)
            }
          >
            Manage Products
          </button>

          {/* ORDERS */}
          <button
            className="manage-btn"
            onClick={() =>
              navigate("/shop/orders")
            }
          >
            Orders
          </button>

        </div>
      )}

    </div>


    {products.length === 0 ? (

      <div className="empty-products">
        No products added yet.
      </div>

    ) : (

      <div className="product-grid">

        {products.map((product) => (

          <div
            key={product.id}
            className="product-card"
          >

            <img
              src={product.image}
              alt={product.name}
              className="product-image"
            />

            <div className="product-info">

              <h4>
                {product.name}
              </h4>

              <p className="price">
                ₹{product.offerPrice || product.price}
              </p>

              {product.offerPrice > 0 &&
                product.offerPrice !== product.price && (
                  <p className="mrp">
                    ₹{product.price}
                  </p>
              )}

              <button
                className="add-cart-btn"
                onClick={() =>
                  handleAddToCart(product)
                }
              >
                Add to Cart
              </button>

            </div>

          </div>

        ))}

      </div>

    )}

  </div>
)}

{/* ==========================================
    SHOP OWNER POSTS
    SAME UI AS /posts
========================================== */}

<div className="shop-posts-wrapper">

  <div className="shop-posts-title">
    <h3>Posts ({shopPosts.length})</h3>
  </div>

  {postsLoading ? (

    <p className="shop-posts-loading">
      Loading posts...
    </p>

  ) : shopPosts.length === 0 ? (

    <div className="shop-posts-empty">
      No posts yet.
    </div>

  ) : (

    <div className="feed-list">

      {shopPosts.map((item) => {

        const likes = item.likes || [];

        const liked =
          user &&
          likes.includes(user.uid);

        return (

          <article
            key={`${item.postType}-${item.id}`}
            id={`post-${item.id}`}
            className="feed-card"
          >

            {/* =========================
                POST HEADER
            ========================= */}

            <header
              className="feed-head"
            >

              {item.userPhotoURL ? (

                <img
                  src={item.userPhotoURL}
                  className="feed-avatar"
                  alt="User"
                />

              ) : (

                <FaUserCircle
                  className="feed-avatar-icon"
                />

              )}

              <div>

                <h4>
                  {item.userName ||
                    shop["Shop Name"]}
                </h4>

                <small>

                  {item.area ||
                    shop.Location}

                  {" • "}

                  {item.createdAt
                    ? new Date(
                        item.createdAt
                      ).toLocaleDateString(
                        "en-IN",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )
                    : ""}

                </small>

              </div>

            </header>


            {/* =========================
                TEXT / CAPTION
            ========================= */}

            {(item.text ||
              item.caption) && (

              <p className="feed-text">
                {item.text ||
                  item.caption}
              </p>

            )}


            {/* =========================
                IMAGE
            ========================= */}

            {item.imageUrl && (

              <img
                src={item.imageUrl}
                className="feed-image"
                alt=""
              />

            )}


            {/* =========================
                VIDEO
            ========================= */}

            {item.videoUrl && (

              <video
                src={item.videoUrl}
                className="video-player"
                controls
                loop
                playsInline
                preload="metadata"
              />

            )}


            {/* =========================
                URL PREVIEW
            ========================= */}

            {item.urlLink && (

              <div
                className="url-preview-card"
                onClick={() => {

                  if (
                    item.urlLink
                  ) {
                    window.open(
                      item.urlLink,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }

                }}
              >

                <div className="url-preview-icon">

                  {(() => {

                    try {

                      const h =
                        new URL(
                          item.urlLink
                        )
                          .hostname
                          .replace(
                            /^www\./,
                            ""
                          );

                      return (
                        h[0]?.toUpperCase() ||
                        "🔗"
                      );

                    } catch {

                      return "🔗";

                    }

                  })()}

                </div>

                <div className="url-preview-text">

                  <div className="url-preview-link read-more">
                    Read More →
                  </div>

                </div>

              </div>

            )}


            {/* =========================
                ACTIONS
            ========================= */}

            <footer className="feed-actions">

              <button
                className={`like-btn ${
                  liked
                    ? "liked"
                    : ""
                }`}
                onClick={() =>
                  handlePostLike(item)
                }
              >

                ❤️{" "}

                {likes.length || ""}

              </button>


              <button
                onClick={async () => {

                  const link =
                    `${window.location.origin}/posts?post=${item.id}`;

                  const shareText =
                    `📍 ${
                      item.area ||
                      shop.Location ||
                      ""
                    }

${
  item.text ||
  item.caption ||
  "Check this update"
}

👇 Open in Eyal App`;

                  if (
                    navigator.share
                  ) {

                    try {

                      await navigator.share({
                        title:
                          shop[
                            "Shop Name"
                          ],
                        text:
                          shareText,
                        url: link,
                      });

                      return;

                    } catch (
                      error
                    ) {

                      if (
                        error?.name ===
                        "AbortError"
                      ) {
                        return;
                      }

                      console.error(
                        "Share failed:",
                        error
                      );

                    }

                  }

                  const whatsappText =
                    `${shareText}

${link}`;

                  window.open(
                    `https://wa.me/?text=${encodeURIComponent(
                      whatsappText
                    )}`,
                    "_blank",
                    "noopener,noreferrer"
                  );

                }}
              >

                ↗ Share

              </button>

            </footer>

          </article>

        );

      })}

    </div>

  )}

</div>

    </div>
  );
}